<template>
  <div class="custom-ui-switch-wrapper">
    <div class="custom-ui-switch">
      <label class="switch" :class="[model ? 'checked' : '', disabled ? 'disabled' : '']">
        <input
          v-model="model"
          type="checkbox"
          :disabled="disabled"
          name="ui-switch"
          :aria-label="label || 'toggle'"
        />
        <span class="slider round" />
      </label>
      <span class="custom-ui-switch-label" v-text="label" />
      <ui-field-info :text="info" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IUISwitch } from '@/types/Components/UIKit'

  const { label = '', disabled = false, info = '' } = defineProps<IUISwitch>()

  const model = defineModel<boolean>({ required: true })
</script>

<style lang="scss" scoped>
  .custom-ui-switch-wrapper {
    @include flexible($direction: column, $align: flex-start);
    width: 100%;

    .custom-ui-switch {
      @include flexible($align: center, $wrap: wrap);
      column-gap: 0.35rem;
      width: 100%;
    }
    .switch {
      width: 41px;
      height: 22px;
      border-radius: 20px;
      background: #dedede;
      display: flex;
      align-items: center;
      padding: 3px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &.disabled {
        cursor: not-allowed;
      }
      &.checked {
        background: $brandColor;
        &.disabled {
          background: $brandColorLight;
        }
        .slider {
          transform: translateX(19px);
        }
      }

      input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      .slider {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #fff;
        transition: all 0.3s ease-in-out;
      }
    }
    .custom-ui-switch-label {
      @include row-label;
    }
  }
</style>
